import { Injectable, signal } from '@angular/core'
import { Topic } from '../interactions/interaction-interface'

@Injectable()
export class Topics {
	readonly selectedTopic = signal<Topic | null>(null)
}
